import { useAppSelector } from './useAppSelector'

export const useSpam = () => useAppSelector((state) => state.spam)
